// src/pages/ResponsiveDesign.tsx
import styled from 'styled-components';

export default function ResponsiveDesign() {
  return (
    <Container>
      <Title>Responsive Design</Title>
      <Subtitle>
        Creating layouts that adapt seamlessly to every screen size and device.
      </Subtitle>

      <Content>
        <Section>
          <h3>Key Concepts</h3>
          <ul>
            <li>Mobile-first approach</li>
            <li>Flexible grids and layouts</li>
            <li>Fluid typography and images</li>
            <li>Adaptive breakpoints</li>
          </ul>
        </Section>

        <Section>
          <h3>Breakpoints Example</h3>
          <CodeBlock>
            {`@media (max-width: 768px) {
  .container {
    flex-direction: column;
  }
}`}
          </CodeBlock>
        </Section>

        <Section>
          <h3>Tools & Libraries</h3>
          <TechGrid>
            <TechItem>CSS Grid</TechItem>
            <TechItem>Flexbox</TechItem>
            <TechItem>Styled Components</TechItem>
            <TechItem>Tailwind CSS</TechItem>
          </TechGrid>
        </Section>
      </Content>
    </Container>
  );
}

// Styled Components
const Container = styled.div`
  padding: 4rem 2rem;
  color: ${({ theme }) => theme.text};
`;

const Title = styled.h1`
  font-size: 2.8rem;
  color: ${({ theme }) => theme.primary};
  margin-bottom: 1rem;
`;

const Subtitle = styled.p`
  font-size: 1.2rem;
  margin-bottom: 3rem;
  color: ${({ theme }) => theme.text};
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
`;

const Section = styled.div`
  h3 {
    font-size: 1.5rem;
    margin-bottom: 1rem;
    color: ${({ theme }) => theme.primary};
  }
  ul {
    list-style: disc;
    padding-left: 1.5rem;
  }
`;

const CodeBlock = styled.pre`
  background: rgba(255, 255, 255, 0.08);
  padding: 1rem;
  border-radius: 0.5rem;
  font-family: monospace;
  white-space: pre-wrap;
`;

const TechGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 1rem;
`;

const TechItem = styled.div`
  background: rgba(255, 255, 255, 0.08);
  padding: 0.8rem;
  border-radius: 0.5rem;
  text-align: center;
  font-weight: bold;
  box-shadow: ${({ theme }) => theme.buttonShadow};
`;
